import React, { useEffect, useState } from 'react';
import {
  Button as MUIButton,
  Grid,
  Paper,
  Card,
  CardMedia,
  CardContent,
  Typography
} from '@material-ui/core';
import { useAppSelector } from '../../../redux/hooks';
import { useHistory } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router';
import View from '../../../components/view/View';
import Button from '../../../components/button/Button';
import ReactPlayer from "react-player/lazy";
import {
  BlockRounded,
  ChevronLeft,
} from '@material-ui/icons';
import { ResourceActionsAsync } from './state/resourceHub-actions.async';
import {
  ResourceState,
} from './state/resourceHub.types';
import { makeStyles } from '@material-ui/core/styles';
import '../../../styles/markdown.scss';
import { isMobile } from 'react-device-detect';
import mixpanel from '../../../utils/mixpanel';

const useStyles = makeStyles({
  card: {
    height: '100%',
    width: '100%',
    maxHeight: 500,
    maxWidth: 350,
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer'
  },
  cardLayout: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'space-between'
  },
  image: {
    maxHeight: 400,
    maxWidth: 600,
    width: "80%",
    borderRadius: 30
  },
  imageMobile: {
    width: "100%",
    borderRadius: 30
  },
  container: {
    padding: 20,
    justifyContent: "center"
  },
  extraPadding: {
    padding: 20
  },
  title: {
    fontSize: '2.5em',
    marginBottom: 10
  },
  titleMobile: {
    textAlign: 'center',
  },
  button: {
    marginRight: 10,
    marginTop: 40
  },
  buttonMobile: {
    textAlign: "center",
    marginTop: 20,
    marginRight: 10,
  },
  paper: {
    padding: 20,
    width: '100%',
  },
  extraMarginRight: {
    marginRight: 10,
  },
  extraMarginBottom: {
    marginBottom: 10,
  },
  topLeftGrid: {
    position: "relative",
    height: 400
  },
  videoCardTitle: {
    fontWeight: 'bold',
    fontSize: '1em'
  }
});
interface VideoCard {
  link: string;
  title: string;
}

const VideoCard: React.FC<VideoCard> = ({
  link,
  title
}: VideoCard) => {
  const styles = useStyles();
  return (
    <Card
      className={styles.card}
    >
      <div >
        <ReactPlayer
          width="100%"
          controls={true}
          light={true}
          url={link}
          onPlay={() => (mixpanel.track("Resource Video Playback from 'All video' section", { 'link': link, 'title': title }))}
        />
      </div>

      <div
        className={styles.cardLayout}
      >
        <CardContent>
          <Typography variant="h6">
            {title}
          </Typography>
        </CardContent>
      </div>
    </Card>
  );
}

const ResourceInfoView: React.FC<any> = (props: any) => {
  const styles = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const md = require('markdown-it')();
  const { match } = props;
  var resourceId = match.params.resourceId;
  const [download, setDownload] = useState(false);
  const [video, setVideo] = useState(false);

  const resourceState = useAppSelector<ResourceState>(
    state => state.resources
  );
  const resource = resourceState.selected;
  const result = md.render(resource.description);

  useEffect(() => {
    dispatch(ResourceActionsAsync.getResource(resourceId));
  }, []);

  useEffect(() => {
    if (resource.type[0] === 'download') {
      setDownload(true);
    } else if (resource.type[0] === 'video') {
      setVideo(true);
    }
  }, [resourceState]);

  return (
    <View
      renderBackButton={() => (
        <Button
          onClick={() =>
            history.goBack()
          }
          className={styles.extraMarginRight}
        >
          <ChevronLeft /> Back
        </Button>
      )}
    >
      <Paper className={styles.paper}>
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
          spacing={4}>

          {/* FIRST ROW */}
          <Grid item md={6} className={isMobile ? '' : styles.topLeftGrid} >
            <h1 className={isMobile ? styles.titleMobile : styles.title} >
              {resource.title}
            </h1>
            <h3>
              Author: {resource.author}
            </h3>
            <div hidden={!download} className={isMobile ? styles.buttonMobile : styles.button}>
              <Button
                primary
                width={300}
                onClick={() => {
                  mixpanel.track("Resource Download Requested", { 'id': resource._id, 'title': resource.title });
                  window.open(resource.link, resource.title)
                }}
              >
                Download
              </Button>
            </div>
          </Grid>

          <Grid hidden={!video} item md={6}>
            <ReactPlayer
              width="100%"
              style={{ padding: 10 }}
              controls={true}
              url={resource.link}
              onPlay={() => (mixpanel.track("Resource Video Playback", { 'id': resource._id, 'title': resource.title }))}

            />
          </Grid>

          {/* This will be hidden if the resource has a video link */}
          <Grid hidden={video} item md={6}>
            <img src={resource.thumbnail} className={isMobile ? styles.imageMobile : styles.image} alt="Logo" />
          </Grid>
        </Grid>

        {/* SECOND ROW */}
        <Grid
          container
          justify="flex-start"
          alignItems="flex-start"
          spacing={4}>
          <Grid item className={styles.extraPadding} >
            <h3 className={styles.extraMarginBottom}>
              {!result.length ? '' : 'DESCRIPTION:'}
            </h3>
            <div className={"markdownContainer"} dangerouslySetInnerHTML={{ __html: String(result) }} />
          </Grid>
        </Grid>

        {/* Third Row if playlist */}
        <div hidden={!video}>
          {(resource.playlist).length > 0 &&
            <h2 style={{ marginTop: 30, marginBottom: 30 }}>
              All Videos:
            </h2>
          }
          <Grid
            container
            spacing={4}
            className={styles.container}
            alignItems="stretch"

          >
            {(resource.playlist).length > 0 && (resource.playlist).map((video: any) => {
              return (
                <Grid item className={styles.extraPadding}>
                  <VideoCard
                    link={video.link}
                    title={video.title}
                  />
                </Grid>
              )
            })
            }
          </Grid>
        </div>
      </Paper>
    </View>
  );
};

export default withRouter(ResourceInfoView);
